import $ from 'jquery';

$(document).ready(() => {

  const $gtag_on = $('body').data('gtag_on');
  let productBeingModified = '';
  if($gtag_on === 1) {

    $('.product-list-details').on('click', (evt) => {
      const $product = $(evt.currentTarget).next('div.product-data');
      dataLayer.push(
        {
          'event': 'ecommerceAction',
          'ecommerce': {
            'click': {
              'actionField': {'list': $product.data('list')},
              'products': [{
                'name': $product.data('name'),
                'id': $product.data('id'),
                'price': $product.data('price'),
                'brand': $product.data('brand'),
                'category': $product.data('category'),
                'variant': $product.data('variant'),
                'position': $product.data('position'),
              }]
            }
          }
        });
    })

    $('.gtag-add-to-cart').on('click', (evt) => {
      const $product = $(evt.currentTarget).next('div.product-data');
      let classStr = '';
      $('#sylius-product-adding-to-cart select').each(function(index) {
        classStr += '.' + $(this).val();
      })
      dataLayer.push(
        {
          'event': 'ecommerceAction',
          'ecommerce': {
            'add': {
              'products': [{
                'name': $product.data('name'),
                'id': $product.data('id'),
                'price': "" + ($('#product-price').text().replace('$', '').replace(',', '').replace('.', '').replace('\n', '').trim()) / 100 + "",
                'brand': $product.data('brand'),
                'category': $product.data('category'),
                'variant': $(classStr).data('variant'),
                'quantity': $('#sylius_add_to_cart_cartItem_quantity').val(),
              }]
            }
          }
        });
    })

    $('.gtag-list-add-to-cart').on('click', (evt) => {
      const $product = $(evt.currentTarget).next('div.product-data');
      dataLayer.push(
        {
          'event': 'ecommerceAction',
          'ecommerce': {
            'add': {
              'products': [{
                'name': $product.data('name'),
                'id': $product.data('id'),
                'price': $product.data('price'),
                'brand': $product.data('brand'),
                'category': $product.data('category'),
                'variant': $product.data('variant'),
                'quantity': $product.data('quantity'),
              }]
            }
          }
        });
    })

    $('.sylius-cart-remove-button').on('click', (evt) => {
      const $product = $(evt.currentTarget).next('div.product-data');
      dataLayer.push(
        {
          'event': 'ecommerceAction',
          'ecommerce': {
            'remove': {
              'products': [{
                'name': $product.data('name'),
                'id': $product.data('id'),
                'price': $product.data('price'),
                'brand': $product.data('brand'),
                'category': $product.data('category'),
                'variant': $product.data('variant'),
                'quantity': $product.data('quantity'),
              }]
            }
          }
        });
    })

    $('.gtagCta').on('click', (evt) => {
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'click',
            'link_text': $(evt.currentTarget).text().replace('$', '').replace('\n', '').trim(),
            'click_type': 'cta click'
          }
        });
    })

    $('.partner-infos a').on('click', (evt) => {
      dataLayer.push(
        {
          'event': 'userAction',
            'interaction': {
            'event_name': 'click',
              'link_url': $(evt.currentTarget).attr('href'),
              'click_type': 'outbound link'
          }
        });
    })

    $('a.phone-links').on('click', (evt) => {
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'click',
            'link_text': $(evt.currentTarget).text().replace('$', '').replace('\n', '').trim(),
            'click_type': 'phone click'
          }
        });
    })

    $('.faq-expand').on('click', (evt) => {
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'faq',
            'link_text': $(evt.currentTarget).text().replace('\n', '').trim(),
          }
        });
    })

    $('#contact-page .submit.button').on('click', (evt) => {
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'generate_lead',
            'lead_type': 'contact form',
            'lead_step': 'success'
          }
        });
    })

    $('.cards.brands a').on('click', (evt) => {
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'click',
            'link_url': $(evt.currentTarget).attr('href'),
            'click_type': 'catalogue'
          }
        });
    })

    $('.account-sidebar .catalog a, .account-sidebar .menu a').on('click', (evt) => {
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'click',
            'link_text': $(evt.currentTarget).text().replace('\n', '').trim(),
            'click_type': 'customer area - menu link'
          }
        });
    })

    $('.cta.gblack.modify.button, .checkout-container .actions .ui.button.modify').on('click', (evt) => {
      const $product = $(evt.currentTarget).next('div.product-data');
      productBeingModified = $product.data('name');
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'product',
            'product_name': $product.data('name'),
            'interaction_type': 'product modification - intention'
          }
        });
    })

    $('.cta.gred.approve.button').on('click', (evt) => {
      const $product = $(evt.currentTarget).next('div.product-data');
      dataLayer.push(
        {
          'event': 'userAction',
          'interaction': {
            'event_name': 'product',
            'product_name': productBeingModified,
            'interaction_type': 'product modification - complete'
          }
        });
    })

  }

});
